import { Header, Title, Subtitle, BalancePanel, BalanceIconWrap, BalanceInfo, BalanceLabel, BalanceValue, BuyButton } from './HomeHeader.styled';
import CurrencyIcon from '../CurrencyIcon';

const HomeHeader = ({ appName, subtitle, balance, currencyTitle, onBuyTokens, theme, t }) => (
	<>
		<Header>
			<Title theme={theme}>{appName}</Title>
			<Subtitle theme={theme}>{subtitle}</Subtitle>
		</Header>
		<BalancePanel theme={theme}>
			<BalanceIconWrap theme={theme}>
				<CurrencyIcon size={72} />
			</BalanceIconWrap>
			<BalanceInfo>
				<BalanceLabel theme={theme}>{currencyTitle} {t('main.balance')}</BalanceLabel>
				<BalanceValue theme={theme}>{balance ? balance.toLocaleString('ru-RU', { maximumFractionDigits: 2 }) : '0'}</BalanceValue>
			</BalanceInfo>
		</BalancePanel>
		<BuyButton theme={theme} onClick={onBuyTokens}>
			{t('buyTokens', { currency: currencyTitle })}
		</BuyButton>
	</>
);

export default HomeHeader; 